import React from 'react';
import Avatar, { SizeType } from '@atlaskit/avatar';

export const ProfileAvatar = ({
  picture,
  size,
  testIdPrefix,
  borderColor,
}: {
  picture: string;
  size?: SizeType;
  testIdPrefix?: string;
  borderColor?: string;
}) => {
  if (picture) {
    return (
      <Avatar
        borderColor={borderColor}
        size={size ? size : 'small'}
        src={picture}
        testId={testIdPrefix ? `${testIdPrefix}-avatar-image` : `avatar-image`}
      />
    );
  }
  return <Avatar size={size ? size : 'small'} />;
};
